/* Inline SVG icon set (24x24, stroke-based) and the Kulaktan logo mark. */

const IC = {
  play: '<path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.5-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5z" fill="currentColor" stroke="none"/>',
  stop: '<rect x="6.5" y="6.5" width="11" height="11" rx="2" fill="currentColor" stroke="none"/>',
  replay: '<path d="M3.5 12a8.5 8.5 0 1 0 2.8-6.3"/><path d="M3.5 4v5h5"/>',
  mic: '<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5.5 11a6.5 6.5 0 0 0 13 0"/><path d="M12 17.5V21"/>',
  micoff:
    '<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5.5 11a6.5 6.5 0 0 0 13 0"/><path d="M12 17.5V21"/><path d="M3.5 3.5l17 17"/>',
  headphones:
    '<path d="M4 15v-3a8 8 0 0 1 16 0v3"/><rect x="3" y="14" width="4.5" height="7" rx="1.5"/><rect x="16.5" y="14" width="4.5" height="7" rx="1.5"/>',
  check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
  x: '<path d="M6 6l12 12M18 6L6 18"/>',
  right: '<path d="M5 12h14M13 6l6 6-6 6"/>',
  left: '<path d="M19 12H5M11 6l-6 6 6 6"/>',
  chev: '<path d="M9 6l6 6-6 6"/>',
  up: '<path d="M12 19V5M6 11l6-6 6 6"/>',
  down: '<path d="M12 5v14M6 13l6 6 6-6"/>',
  star: '<path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z"/>',
  flame: '<path d="M12 3c1 3.5 5 5.5 5 10a5 5 0 0 1-10 0c0-2.2 1-3.6 2.3-4.9.2 1.7 1 2.7 2.2 3.2C11 9 11.2 6 12 3z"/>',
  sliders: '<path d="M4 7h10M18 7h2M4 17h4M12 17h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/>',
  chart: '<path d="M5 20V10M12 20V4M19 20v-7"/>',
  book: '<path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15H6.5A2.5 2.5 0 0 0 4 20.5z"/><path d="M4 20.5A2.5 2.5 0 0 1 6.5 18H20v3H6.5"/>',
  target:
    '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="4.5"/><circle cx="12" cy="12" r="1" fill="currentColor"/>',
  trophy:
    '<path d="M8 4h8v5a4 4 0 0 1-8 0z"/><path d="M8 6H5a3 3 0 0 0 3 4M16 6h3a3 3 0 0 1-3 4"/><path d="M12 13v3.5M8.5 20.5h7M10 16.5h4v4h-4z"/>',
  home: '<path d="M4 11l8-7 8 7v9h-5v-6H9v6H4z"/>',
  menu: '<path d="M4 7h16M4 12h16M4 17h16"/>',
  volume: '<path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z"/><path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11"/>',
  award: '<circle cx="12" cy="9" r="5.5"/><path d="M8.5 13.5L7 21l5-2.5 5 2.5-1.5-7.5"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5v.5"/>',
  bulb: '<path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.6 10.8c.8.6 1.1 1.3 1.1 2.2h5c0-.9.3-1.6 1.1-2.2A6 6 0 0 0 12 3z"/>',
  alert: '<path d="M12 4l9.5 16h-19z"/><path d="M12 10v4.5M12 17.5v.5"/>',
  skip: '<path d="M6 6l8 6-8 6z" fill="currentColor"/><path d="M18 6v12"/>',
  loop: '<path d="M17 3l3 3-3 3"/><path d="M4 11V9a3 3 0 0 1 3-3h13"/><path d="M7 21l-3-3 3-3"/><path d="M20 13v2a3 3 0 0 1-3 3H4"/>',
  wave: '<path d="M3.5 12h1.5M7.5 8.5v7M11 5v14M14.5 8v8M18 10.5v3M20.5 12h0"/>',
  download: '<path d="M12 4v11M7 10l5 5 5-5M5 20h14"/>',
  tuner: '<path d="M4 16a8 8 0 0 1 16 0"/><path d="M12 16l4-6"/><circle cx="12" cy="16" r="1.2" fill="currentColor"/>',
  metronome: '<path d="M9 3h6l4 18H5z"/><path d="M12 15l5-9"/><path d="M8 17.5h8"/>',
  grid: '<rect x="4" y="4" width="6.5" height="6.5" rx="1.5"/><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.5"/><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.5"/><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.5"/>',
  lock: '<rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>',
  pick: '<path d="M12 21c-3.5-2.7-7-7.2-7-11.2C5 6 8.2 3.5 12 3.5S19 6 19 9.8c0 4-3.5 8.5-7 11.2z"/><path d="M8.3 10.6c1.2-1.5 2.4-1.5 3.7 0s2.5 1.5 3.7 0"/>',
  note: '<path d="M9 18V5.5l10-2v12"/><circle cx="6.5" cy="18" r="2.5"/><circle cx="16.5" cy="15.5" r="2.5"/>',
  voice:
    '<path d="M8 14.5a4 4 0 0 1-1-2.7V9a5 5 0 0 1 10 0v2.8a4 4 0 0 1-1 2.7"/><path d="M9.5 18.5c1.5 1 3.5 1 5 0"/><path d="M3 9.5v3M21 9.5v3"/>',
  chordbox:
    '<rect x="5" y="3.5" width="14" height="17" rx="1.2"/><path d="M5 8.5h14M5 13.5h14M9.7 3.5v17M14.3 3.5v17"/><circle cx="9.7" cy="11" r="1.5" fill="currentColor"/><circle cx="14.3" cy="6" r="1.5" fill="currentColor"/>',
  ear: '<path d="M6.5 9.5a5.5 5.5 0 0 1 11 0c0 3.2-3.3 3.9-3.3 7a2.6 2.6 0 0 1-4.9 1.2"/><path d="M9.8 9.8a2.2 2.2 0 0 1 4.4 0c0 1.3-1.4 1.7-1.4 2.8"/>',
  keys: '<rect x="3" y="5" width="18" height="14" rx="1.5"/><path d="M8 13v6M12 13v6M16 13v6"/><path d="M7 5v8h2V5M11 5v8h2V5M15 5v8h2V5"/>',
  sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.2 5.2l1.4 1.4M17.4 17.4l1.4 1.4M5.2 18.8l1.4-1.4M17.4 6.6l1.4-1.4"/>',
  moon: '<path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z"/>',
  lungs:
    '<path d="M12 4v7M12 11c-1.5 0-3 1-3 3"/><path d="M12 11c1.5 0 3 1 3 3"/><path d="M8.5 7.5C6 8 4 11 4 15c0 2.5 1 4.5 3 4.5 2 0 2.5-2 2.5-4V9"/><path d="M15.5 7.5C18 8 20 11 20 15c0 2.5-1 4.5-3 4.5-2 0-2.5-2-2.5-4V9"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  minus: '<path d="M5 12h14"/>',
  spark:
    '<path d="M10.5 6.5q.7 6.3 7 7-6.3.7-7 7-.7-6.3-7-7 6.3-.7 7-7z"/><path d="M18 3q.3 2.7 3 3-2.7.3-3 3-.3-2.7-3-3 2.7-.3 3-3z"/>',
  jam: '<path d="M13.6 10.4l5.6-5.6"/><path d="M18.2 3.4l2.4 2.4"/><path d="M11.4 8.6c-1.2-1-3-.8-4 .4l-.5.7c-.3.4-.8.6-1.3.6C4 10.4 3 11.7 3 13.4c0 1.7.8 3.3 2.1 4.5 1.2 1.3 2.8 2.1 4.5 2.1 1.7 0 3-1 3.1-2.6 0-.5.2-1 .6-1.3l.7-.5c1.2-1 1.4-2.8.4-4z"/><path d="M8.3 13.5l2.2 2.2"/><circle cx="7.8" cy="16.2" r=".9" fill="currentColor"/>',
  tap: '<path d="M9 11V5.5a1.5 1.5 0 0 1 3 0V11"/><path d="M12 10.5V9a1.5 1.5 0 0 1 3 0v2"/><path d="M15 10.5a1.5 1.5 0 0 1 3 0V15a6 6 0 0 1-6 6h-.5a6 6 0 0 1-5-2.7L4 14.5a1.5 1.5 0 0 1 2.4-1.8L9 15"/>',
} as const;

export type IconName = keyof typeof IC;

export function Icon({ name, className }: { name: IconName; className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={`ic${className ? ` ${className}` : ''}`}
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: static, trusted icon paths
      dangerouslySetInnerHTML={{ __html: IC[name] ?? IC.info }}
    />
  );
}

export function Logo() {
  return (
    <svg viewBox="0 0 40 40" className="logo-mark" aria-hidden="true">
      <rect x="1" y="1" width="38" height="38" rx="11" fill="var(--accent)" />
      <circle cx="20" cy="20" r="10.5" fill="none" stroke="var(--on-accent)" strokeWidth="2.2" opacity=".35" />
      <path d="M7 14.5h26M7 25.5h26" stroke="var(--on-accent)" strokeWidth="1.6" strokeLinecap="round" opacity=".7" />
      <path
        d="M7 20c2.2-4.6 4.4-4.6 6.5 0s4.3 4.6 6.5 0 4.3-4.6 6.5 0 4.3 4.6 6.5 0"
        fill="none"
        stroke="var(--on-accent)"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
    </svg>
  );
}
